import { createSlice, current } from '@reduxjs/toolkit';

const userRoleSlice = createSlice({
  name: 'roles',
  initialState: {
    activeTab: 'permissions',
    userRoleOptions: [],
    roleActionData: [],
    selectedUserRole: null,
    selectedUserRoleCopy: null,
    permissionData: [],
    selectedModule: null,
    isPermissionCheckedAll: false,
    moduleOptions: [],
    createAction: {
      module_action_id: 0,
      module_action_module_id: 0,
      module_action_name: '',
      module_action_slug: '',
      module_name: '',
      module_slug: ''
    },
    createRole: {
      role_id: 0,
      role_name: '',
      role_slug: '',
      role_type: null
    },
    createModule: {
      module_id: 0,
      module_name: '',
      module_slug: '',
      module_visible: 1
    }
  },
  reducers: {
    handleActiveTab: {
      reducer(state, action) {
        state.activeTab = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handlePermissionCheckedAll: {
      reducer(state, action) {
        state.isPermissionCheckedAll = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleCreateRole: {
      reducer(state, action) {
        state.createRole = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleCreateModule: {
      reducer(state, action) {
        state.createModule = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleSelectedUserRole: {
      reducer(state, action) {
        state.selectedUserRole = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleSelectedUserRoleCopy: {
      reducer(state, action) {
        state.selectedUserRoleCopy = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleSelectedModule: {
      reducer(state, action) {
        const obj = action.payload;
        const createAction = current(state).createAction;

        state.selectedModule = obj;
        state.createAction = {
          ...createAction,
          module_action_module_id: obj?.module_id || 0,
          module_name: obj?.module_name || '',
          module_slug: obj?.module_slug || '',
          module_action_slug:
            createAction?.module_action_id === 0
              ? obj?.module_slug
                ? `${obj?.module_slug}-`
                : ''
              : createAction?.module_action_slug
        };
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handlePermissionData: {
      reducer(state, action) {
        state.permissionData = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleUserRoleOptions: {
      reducer(state, action) {
        state.userRoleOptions = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleModuleOptions: {
      reducer(state, action) {
        state.moduleOptions = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleRoleActionData: {
      reducer(state, action) {
        state.roleActionData = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleCreateAction: {
      reducer(state, action) {
        state.createAction = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    }
  }
});

export const {
  handleActiveTab,
  handlePermissionCheckedAll,
  handleSelectedUserRole,
  handleSelectedUserRoleCopy,
  handlePermissionData,
  handleUserRoleOptions,
  handleModuleOptions,
  handleRoleActionData,
  handleCreateAction,
  handleCreateRole,
  handleSelectedModule,
  handleCreateModule
} = userRoleSlice.actions;
export default userRoleSlice.reducer;
